import { createSelector } from 'reselect';
import { RootState } from 'store';
import adapter from './counterOfferProposals.adapter';
import { ProposalParams } from '../proposals.types';
import { REDUCER_KEY } from './counterOfferProposals.consts';
import { normalizeDateFromApi } from 'helpers/datetimeHelpers';
import { calculateTimeBoundaries } from '../proposals.utils';

const selectors = adapter.getSelectors(
  (state: RootState) => state[REDUCER_KEY],
);
export const { selectIds, selectTotal, selectAll } = selectors;

export const selectById = (
  state: RootState,
  id: number,
): ProposalParams | null => selectors.selectById(state, id) || null;

export const selectCurrentCounterOfferProposalId = (state: RootState): number =>
  state[REDUCER_KEY].current;

export const selectAllProposals = createSelector(
  state => selectors.selectAll(state),
  finalizedProposals => finalizedProposals || [],
);

export const selectCurrentCounterOfferProposal = createSelector(
  state => selectCurrentCounterOfferProposalId(state),
  state => selectAll(state),
  (currentProposalId, allProposals) =>
    allProposals.find(proposal => proposal?.id === currentProposalId) || null,
);

export function selectCounterOfferProposal(
  state: RootState,
  proposalId: number,
): ProposalParams | undefined {
  return selectors.selectById(state, proposalId) || undefined;
}

export const selectCurrentCounterOfferProposalFlightBoundaries = createSelector(
  selectCurrentCounterOfferProposal,
  proposal => {
    if (!proposal) {
      return null;
    }
    return {
      startDate: proposal.flightTimeBoundaries?.startDate
        ? normalizeDateFromApi(proposal.flightTimeBoundaries.startDate)
        : null,
      endDate: proposal.flightTimeBoundaries?.endDate
        ? normalizeDateFromApi(proposal.flightTimeBoundaries.endDate)
        : null,
    };
  },
);

export const selectCurrentCounterOfferProposalTimeBoundaries = createSelector(
  selectCurrentCounterOfferProposal,
  calculateTimeBoundaries,
);
